import { createApp } from 'vue'
import LegalText from './LegalText'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--legal-text'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((LegalTextDOM) => {
            const props = handleComponentProps(LegalText, LegalTextDOM)
            const component = createApp(LegalText, props).use(Store)
            component.mount(LegalTextDOM)
        })
    }
}
